import { Icon } from "@iconify/react";
import React from "react";
import { NavLink } from "react-router-dom";
import AuthUser from "../../Hooks/authUser";
import logo from "../../Assets/logo.png";

const DoctorDashboardNav = ({ onClose }) => {
  const { userInfo, logout } = AuthUser();

  const navItems = [
    {
      to: "overview",
      icon: "material-symbols:team-dashboard-outline-rounded",
      activeIcon: "material-symbols:team-dashboard-rounded",
      label: "Overview",
    },
    {
      to: "patients",
      icon: "solar:users-group-rounded-linear",
      activeIcon: "solar:users-group-rounded-bold",
      label: "Patients",
    },
    {
      to: "statistics",
      icon: "solar:graph-up-linear",
      activeIcon: "solar:graph-up-bold",
      label: "Statistics",
    },
    {
      to: "doctor-add-new-patient",
      icon: "fluent:person-add-24-regular",
      activeIcon: "fluent:person-add-24-filled",
      label: "Add Patient",
    },
    {
      to: "billing",
      icon: "solar:wallet-money-linear",
      activeIcon: "solar:wallet-money-bold",
      label: "Billing & Plans",
    },
    {
      to: "faq",
      icon: "solar:question-square-linear",
      activeIcon: "solar:question-square-bold",
      label: "FAQ Support",
    },
    {
      to: "editProfile",
      icon: "solar:user-id-linear",
      activeIcon: "solar:user-id-bold",
      label: "Edit Profile",
    },
    {
      to: "changePassword",
      icon: "solar:key-linear",
      activeIcon: "solar:key-bold",
      label: "Change Password",
    },
  ];

  return (
    <div className="flex flex-col h-full bg-[#1e1b4b] text-slate-300 w-64 border-r border-slate-800">
      {/* Brand logo section */}
      <div className="flex items-center justify-center px-6 py-5 border-b border-slate-800 bg-[#17143a]">
        <a href="/" className="flex items-center gap-2">
          <img className="h-9 w-auto object-contain brightness-125" src={logo} alt="medmyne logo" />
         
        </a>
        {onClose && (
          <button onClick={onClose} className="lg:hidden text-slate-400 hover:text-white p-1 rounded-lg hover:bg-slate-800 transition">
            <Icon icon="lucide:x" className="text-xl" />
          </button>
        )}
      </div>

      {/* Navigation Links */}
      <nav className="flex-1 px-4 py-6 space-y-1 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={onClose}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition duration-200 text-sm font-medium ${
                isActive
                  ? "bg-[#291D89] text-white shadow-lg shadow-indigo-900/30 font-semibold"
                  : "text-slate-400 hover:bg-slate-800/50 hover:text-slate-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  icon={isActive ? item.activeIcon : item.icon}
                  className={`text-xl ${isActive ? "text-[#01AEEF]" : "text-slate-400 group-hover:text-slate-200"}`}
                />
                <span>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Doctor profile card & Logout */}
      <div className="p-4 border-t border-slate-800 bg-[#17143a]">
        <div className="flex items-center gap-3 px-2 py-3 rounded-xl bg-slate-800/40 border border-slate-800/50 mb-3">
          <div className="w-10 h-10 rounded-full bg-[#291D89] text-white flex items-center justify-center font-bold text-lg border border-indigo-500/30">
            {userInfo?.name ? userInfo.name.charAt(0).toUpperCase() : "D"}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-bold text-white truncate">{userInfo?.name || "Doctor"}</p>
            <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-emerald-400 mt-0.5">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"></span>
              Available
            </span>
          </div>
        </div>

        <button
          onClick={logout}
          className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-rose-500/20 hover:border-rose-500 text-rose-400 hover:text-white hover:bg-rose-500/10 transition duration-200 text-sm font-medium"
        >
          <Icon icon="solar:logout-linear" className="text-lg" />
          <span>Sign Out</span>
        </button>
      </div>
    </div>
  );
};

export default DoctorDashboardNav;
